window.$catalog_work_orders_result = [];
window.$catalog_work_orders_treeChangeStatus = false;
window.$catalog_work_orders_page_number = 1;
window.$catalog_work_orders_Glist = [];
window.$catalog_work_orders_selectedRow = [];
window.$catalog_work_orders_content = [];
window.$catalog_work_orders_sliderImages = [];
window.$catalog_work_orders_context = null;
window.$catalog_work_orders_refresh = function (){};
window.$catalog_work_orders_actions = [
  {
    id: "787cf96e-0c70-4b20-8e4c-2ac70224b82c",
    text: "Beheereenheid toevoegen",
    class: "locate",
    modal: "beheereenheid_toevoegen",
  },
  {
    id: "8c5da794-f8da-4549-9b48-f7123c59642a",
    text: "Plaats in map",
    class: "locate",
    modal: "modal_koppel_aan_folder",
  },
  {
    id: "df461440-0f13-40f8-a8c3-c8b2a6f7c4e8",
    text: "Toevoegen toezichthouder(s)",
    class: "locate",
    modal: "toevoegen_toezichthouder",
  },
  {
    id: "0f2c4cd8-bd15-48d9-b66b-6292ace8881f",
    text: "Selecteren directievoerder",
    class: "locate",
    modal: "selecteren_directievoerder",
  },
  {
    id: "c2c28e89-63ee-4714-8051-4b425f2c0976",
    text: "Toevoegen uitvoerder(s)",
    class: "locate",
    modal: "toevoegen_uitvoerder",
  },
];

window.$catalog_work_orders_algemeenNaam = [];
window.$catalog_work_orders_algemeenCode = [];
window.$catalog_work_orders_algemeenOmschrijving = [];
window.$catalog_work_orders_algemeenStatus = [];

window.$catalog_work_orders_scroll_change = false;
window.$catalog_work_orders_lastUsedTableFilter = {
  content: [],
  definitions: [],
};
window.$catalog_work_orders_selectedIds = null;
window.$catalog_work_orders_column_list = null;
window.$catalog_work_orders_newInsertId = null;
window.$catalog_work_orders_table_total_row_count = 0;
window.$catalog_work_orders_columnListPure = null;
window.$catalog_work_orders_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>work-orders",
        column_list: [
          "checkbox",
          "active",
          "Naam",
          "Omschrijving",
          "paperclip",
          "Datum aangemaakt",
          "Datum laatst gewijzigd",
        ],
      },
    ],
  },
};
